export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14722.f11179e6.jpg";